export const OrderStatus = {
    AllActive: 'All Active',
    Available: 'Available',
    InProgress: 'In Progress',
    Complete: 'Complete',
    Cancelled: 'Cancelled',
    NotAvailable: 'Not Available',
};